import React from "react";
import { connect } from "react-redux";

import Color from "./Color";

class ColorCollapsible extends React.Component {
  state = {
    expanded: false,
  };

  // Collapse/expand the color set when the title is clicked
  toggleCollapsed = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  };

  onExpandColors = () => {
    // Set id to null if the color group is already selected so that we can toggle the selected state
    const id =
      this.props.selectedColorId === this.props.categoryId
        ? null
        : this.props.categoryId;
    this.props.handleExpandColors(id);
  };

  sortColorsByStockStatus = (colors) => {
    // Create a copy of the colors array to avoid mutating props
    return [...colors].sort((a, b) => {
      // If a is in stock and b is out of stock, a comes first
      if (!a.out_of_stock_until && b.out_of_stock_until) {
        return -1;
      }
      // If a is out of stock and b is in stock, b comes first
      if (a.out_of_stock_until && !b.out_of_stock_until) {
        return 1;
      }
      // If both have the same stock status, maintain their original order
      return 0;
    });
  };

  render() {
    const selectedColor = this.props.selectedColor || null,
      colorGroupSelected = false;

    let selectedColorId = "";

    if (selectedColor) {
      selectedColorId = selectedColor.category_id;
    }

    // Sort colors to move out-of-stock items to the end
    const sortedColors = this.sortColorsByStockStatus(this.props.colors);

    const colorDetails = sortedColors.map((color) => {
      return (
        <Color
          layerId={this.props.layerId}
          type={this.props.type}
          key={color.id}
          color={color}
        />
      );
    });

    const colorList = <div className="color-wrapper">{colorDetails}</div>;

    if (this.props.selectedNapkinType !== "photo") {
      return (
        <div
          className={`colorgroup collapsible ${this.props.selectedColorId === this.props.categoryId ? "expanded" : "collapsed"}`}
        >
          <div
            className="collapsible__parent colorgroup__parent"
            onClick={this.onExpandColors}
          >
            <h4 className="">{this.props.title}</h4>

            {/* If selected color is part of the group, output it's color here */}
            {selectedColor && selectedColorId === this.props.categoryId && (
              <div
                className="colorgroup__current"
                style={{ backgroundImage: `url(${selectedColor.thumbnail})` }}
              />
            )}
          </div>

          <div className="collapsible__child colorgroup__colors">
            {/* Output name of currently selected color */}
            {selectedColor && selectedColorId === this.props.categoryId && (
              <div className="colorgroup__current-text">
                {selectedColor.name}
              </div>
            )}

            <div className="color__list">{colorList}</div>
          </div>
        </div>
      );
    } else {
      // Photo/Full Color type shouldn't return a collapsible list of colors, since there's only one color group
      return (
        <div className="colorgroup">
          <div
            className="colorgroup__current"
            style={{
              backgroundColor: `rgb(${this.props.productColor.colorValue})`,
            }}
          />
          <div className="colorgroup__colors">
            <div className="colorgroup__current-text">
              {/* Ouput name of currently selected color */}
              {colorGroupSelected && selectedColor.name}
            </div>
            {colorList}
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
  };
}

export default connect(mapStateToProps)(ColorCollapsible);
